import axios from 'axios';

const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

export default class BanksService {
  static getHeaders() {
    const token = JSON.parse(localStorage.getItem('accessToken'));
    return { Authorization: `Bearer ${token}` };
  }

  static async getBanks(iso = 'CL') {
    try {
      const res = await axios.get(`${ADMIN_URL}/banks?iso=${iso}`, {
        headers: this.getHeaders()
      });
      return { status: 'ok', data: res.data.data };
    } catch {
      return { status: 'error' };
    }
  }

  static async getUserBankData(userId) {
    try {
      const res = await axios.get(`${ADMIN_URL}/user-bank/${userId}`, {
        headers: this.getHeaders()
      });
      return { status: 'ok', data: res.data.data };
    } catch {
      return { status: 'error' };
    }
  }

  static async saveBankData(userId, bankId, payload) {
    try {
      const res = await axios.post(`${ADMIN_URL}/user-bank/${userId}/${bankId}`, payload, {
        headers: this.getHeaders()
      });
      return { status: 'ok', data: res.data.data };
    } catch {
      return { status: 'error' };
    }
  }
}
